// Map function
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
export function map(array, block) {
    var i;
    var il = array.length;
    var result = [];
    for(i = 0; i < il; i++){
        result.push(block(array[i]));
    }
    return result;
}
// Filter function
export function filter(array, block) {
    var i;
    var il = array.length;
    var result = [];
    for(i = 0; i < il; i++){
        if (block(array[i])) {
            result.push(array[i]);
        }
    }
    return result;
}
// Degrees to radians
export function radians(d) {
    return d % 360 * Math.PI / 180;
}
// Radians to degrees
export function degrees(r) {
    return r * 180 / Math.PI % 360;
}
// Convert camel cased string to dash separated
export function unCamelCase(s) {
    return s.replace(/([A-Z])/g, function(m, g) {
        return '-' + g.toLowerCase();
    });
}
// Capitalize first letter of a string
export function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
// Calculate proportional width and height values when necessary
export function proportionalSize(element, width, height, box) {
    if (width == null || height == null) {
        box = box || element.bbox();
        if (width == null) {
            width = box.width / box.height * height;
        } else if (height == null) {
            height = box.height / box.width * width;
        }
    }
    return {
        width: width,
        height: height
    };
}
/**
 * This function adds support for string origins.
 * It searches for an origin in o.origin o.ox and o.originX.
 * This way, origin: {x: 'center', y: 50} can be passed as well as ox: 'center', oy: 50
 **/ export function getOrigin(o, element) {
    var origin = o.origin;
    // First check if origin is in ox or originX
    var ox = o.ox != null ? o.ox : o.originX != null ? o.originX : 'center';
    var oy = o.oy != null ? o.oy : o.originY != null ? o.originY : 'center';
    // Then check if origin was used and overwrite in that case
    if (origin != null) {
        ;
        var ref;
        ref = _sliced_to_array(Array.isArray(origin) ? origin : (typeof origin === "undefined" ? "undefined" : _type_of(origin)) === 'object' ? [
            origin.x,
            origin.y
        ] : [
            origin,
            origin
        ], 2), ox = ref[0], oy = ref[1], ref;
    }
    // Make sure to only call bbox when actually needed
    var condX = typeof ox === 'string';
    var condY = typeof oy === 'string';
    if (condX || condY) {
        var _element_bbox = element.bbox(), height = _element_bbox.height, width = _element_bbox.width, x = _element_bbox.x, y = _element_bbox.y;
        // And only overwrite if string was passed for this specific axis
        if (condX) {
            ox = ox.includes('left') ? x : ox.includes('right') ? x + width : x + width / 2;
        }
        if (condY) {
            oy = oy.includes('top') ? y : oy.includes('bottom') ? y + height : y + height / 2;
        }
    }
    // Return the origin as it is if it wasn't a string
    return [
        ox,
        oy
    ];
}
var descriptiveElements = new Set([
    'desc',
    'metadata',
    'title'
]);
export var isDescriptive = function(element) {
    return descriptiveElements.has(element.nodeName);
};
export var writeDataToDom = function(element, data) {
    var defaults = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var cloned = _object_spread({}, data);
    for(var key in cloned){
        if (cloned[key].valueOf() === defaults[key]) {
            delete cloned[key];
        }
    }
    if (Object.keys(cloned).length) {
        element.node.setAttribute('data-svgjs', JSON.stringify(cloned)) // see #428
        ;
    } else {
        element.node.removeAttribute('data-svgjs');
        element.node.removeAttribute('svgjs:data');
    }
};
